import { h } from "@stencil/core"
export default function SearchResult(props: any) {
  let results = props.results || props
  let linkTarget = props.linkTarget || "_blank"

  return (
    <div class="results">
      <ul role="list" class="cta-search-results">
        {results?.map(result => {
          return (
            <li key={result.title} class="cta-search-results-list">
              {/* <div class="result">
                        <h2>{result.title}</h2>
                        <p>{result.description}</p>
                      </div> */}
              <div class="px-4 sm:px-6 lg:px-8">
                <div class="cta-search-container">
                  <div class="cta-search-container-two">
                    <div class="results-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5" />
                      </svg>
                    </div>
                    <div class="cta-search-container-three">
                      <p class="cta-search-text">
                        <a href={result.link} target={linkTarget}>
                          <span class="cta-search-text-position"></span>
                          {result.title}
                        </a>
                      </p>
                      <p class="cta-search-description">
                        <a href={result.link} class="relative truncate hover:underline" target={linkTarget}>
                          {result.description}
                        </a>
                      </p>
                    </div>
                  </div>
                  <div class="cta-search-list-arrow">
                    <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path
                        fill-rule="evenodd"
                        d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
